import request from '@/utils/request';

export function getList(data) {
  return request({
    url: '/computationUnits/load',
    method: 'post',
    data
  });
}

export function loadForRole(roleId) {
  return request({
    url: '/computationUnits/loadForRole',
    method: 'get',
    params: { appId: '', firstId: roleId }
  });
}

export function add(data) {
  return request({
    url: '/computationUnits/add',
    method: 'post',
    data
  });
}

export function update(data) {
  return request({
    url: '/computationUnits/update',
    method: 'post',
    data
  });
}

export function del(data) {
  return request({
    url: '/computationUnits/delete',
    method: 'post',
    data
  });
}

export function get(id) {
  return request({
    url: '/computationUnits/Get',
    method: 'get',
    params: { id: id }
  });
}

export function getloadfile(data) {
  return request({
    url: '/computationUnits/GetLoadFile',
    method: 'post',
    responseType: 'arraybuffer',
    data
  });
}
